import type { RouteRecordRaw } from 'vue-router';
import { SupportFaqRoutes } from './modules/Faq';
import { SupportGuidesRoutes } from './modules/Guides';
import { SupportHowToRoutes } from './modules/HowTo';
import { SupportHomeRoutes } from './modules/Home';

export default <RouteRecordRaw[]>[
  {
    path: '/support',
    component: () => import('../../../layouts/TheMainLayout/TheMainLayout.vue'),
    redirect: () => '/support/home',
    children: [...SupportFaqRoutes, ...SupportGuidesRoutes, ...SupportHomeRoutes, ...SupportHowToRoutes],
    meta: {
      isSupport: true,
    },
  },
];
